import React from 'react';
import classes from './Logo.module.scss';

const Logo = () => {
  return <div className={classes.Logo}>Movie Box</div>;
};

export default Logo;
